import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GRAY_DARK} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export default function VisibilityToggle({
  isVisible,
  onClick,
}: {
  isVisible: boolean;
  onClick: React.MouseEventHandler<HTMLSpanElement>;
}): JSX.Element {
  return (
    <BenchlingIcon
      className={css(styles.visibilityIcon)}
      icon={isVisible ? 'eye' : 'eye-slash'}
      onClick={onClick}
    />
  );
}

const styles = StyleSheet.create({
  visibilityIcon: {
    color: GRAY_DARK,
    cursor: 'pointer',
  },
});
